import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'tipoOpciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.scss']
})
export class OpcionesComponent implements OnInit {

  @Input('tipo') tipoPregunta: number;
  @Input('textoEntrada') textoEntrada?: string;
  @Input('idsOpcionesBD') idsOpcionesBD?: any[];
  @Input('pasoCompleto') pasoCompleto?: boolean;

  @Output() textoPregunta: EventEmitter<string> = new EventEmitter();
  @Output() guardaPreguntaBD: EventEmitter<boolean> = new EventEmitter();
  @Output() guardaOpcionBD: EventEmitter<any> = new EventEmitter();
  @Output() borrarOpcionBD: EventEmitter<number> = new EventEmitter();

  ////VARIABLES
  opciones: any[] = [
                      {iterador:0},
                      {iterador:1}
                    ];
  iterador = 2;

  boolTextoPregunta = false;

  boolPregAnterior: boolean[] = [true];

  //etiquetas para encontrar los textos de traduccion
  mensajesTraducirKeys: string[] = [
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.MENSAJES.BORRAR',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.SI',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.BOTONES.NO',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.MENSAJES.SINPREG',
    'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.MULTI.MENSAJES.SINANTE',
  ]
  //variables que tomaran las traducciones indicadas en la variable anterior
  //deben ir en el mismo orden
  mensajesTraducirTS = {
    borrar: '',
    si: '',
    no: '',
    sinpreg: '',
    sinante: ''
  };

  constructor(
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    this.validaTextoExistente();
    this.colocaOpcionesRespuesta();
    this.traduceTextosTS();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
  }

  validaTextoExistente(){
    if(this.textoEntrada && this.textoEntrada.length > 0)
      this.boolTextoPregunta = true;
  }

  colocaOpcionesRespuesta(){
    // console.log("idsopcionesbd:");
    // console.log(this.idsOpcionesBD);
    if(this.idsOpcionesBD.length > 0)
    {
      this.opciones = [];
      let iterBoolPregAnt = 0;
      this.idsOpcionesBD.forEach( (opcion) => {
        this.opciones.push({iterador:opcion.idOpcionIter, datos:opcion.idOpcionBD});
        this.iterador = opcion.idOpcionIter;
        this.boolPregAnterior[iterBoolPregAnt] = true;
        iterBoolPregAnt++;
      });
      this.boolPregAnterior[iterBoolPregAnt] = true;
      //deja el iterador una posicion adelante para la siguiente opcion
      this.iterador++;
      /*Si solo hay una respuesta almacenada en bd, se agrega una respuesta vacia
        para que forzosamente haya dos respuestas*/
      if(this.idsOpcionesBD.length == 1){
        this.agregaOpcion();
      }
    }
  }

  agregaOpcion(){
    this.opciones.push({iterador:this.iterador});
    this.iterador++;
  }

  borrarOpcion(id: number){
    let index = 0;
    var BreakException = {};
    try {
        this.opciones.forEach(function(elemento) {
          if(elemento.iterador === id) throw BreakException;
          index++;
        });
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    ///ventana modal de pregunta
    Swal.fire({
      /*title: 'Are you sure?',*/
      title: this.mensajesTraducirTS.borrar,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      
      
      confirmButtonText: this.mensajesTraducirTS.si,
      cancelButtonText: this.mensajesTraducirTS.no
    }).then((result) => {
      if (result.value) {
        // Swal.fire({
        //   text: 'La opción de respuesta fue borrada',
        //   type: 'success'
        // });
        this.opciones.splice(index,1);
        this.borrarOpcionBD.emit(id);
      }
    });
    // this.opciones.splice(index,1);
    // this.openSnackBar("Se eliminó la opción de respuesta","OK");
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.opciones, event.previousIndex, event.currentIndex);
  }

  guardaPregunta(){
    this.guardaPreguntaBD.emit(true);
  }

  enviaTextoPregunta(event){
    this.textoPregunta.emit(event.target.value);
    if(event.target.value.length > 0){
      this.boolTextoPregunta = true;
    }
    else this.boolTextoPregunta = false;
  }

  adverPregunta(indice:number){
    if(!this.boolTextoPregunta){
      Swal.fire({
        icon: 'warning',
        title: this.mensajesTraducirTS.sinpreg,
        confirmButtonColor: '#e40601'/*,
        timer: 1500*/
      });
    }
    else{
      if(!this.boolPregAnterior[indice]){
        Swal.fire({
          icon: 'warning',
          title: this.mensajesTraducirTS.sinante,
          confirmButtonColor: '#e40601'
        });
      }
    }
  }

  private guardaOpcion(event:any, iter:number, orden:number){
    if(event.target.value.length > 0){
      // this.guardaOpcionBD.emit(event.target.value);
      let objetoOpcion: any = {textoOpcion:event.target.value, idOpcion:iter, orden:orden};
      this.guardaOpcionBD.emit(objetoOpcion);
      this.boolPregAnterior[orden+1] = true;
    }
    // console.log(event.target.value);
    // console.log(iter);
  }
}
